import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-2 h-[250px] overflow-auto pr-1" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_3 = { class: "mb-3 pr-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "text-sm text-gray-800" }, "Gerenciar Permissões de Acesso"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] text-gray-500" }, "Clique aqui para filtrar e editar")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "py-4 text-center text-gray-500 text-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "py-4 text-center flex justify-center w-full"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-2 pr-2 h-[40px]" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "title" }, "Grupos ou Pessoas com acesso")
], -1)
const _hoisted_8 = { class: "flex mt-4" }

import { mdiClose, mdiMagnify } from '@mdi/js'
import type { AuthorizationRelationResponseExpanded } from '@/Network/Types/Responses/AuthorizationResponses'
import CardNoSharedResource from '../../Cards/CardNoSharedResource.vue'
import PermissionsAccordionItem, {
  type SelectablePermission,
  type SortedPermItem
} from './PermissionsAccordionItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsAccordionList',
  props: {
    permissionGroups: {},
    permissionUsers: {},
    filterText: {},
    showFilterInput: { type: Boolean },
    isLoading: { type: Boolean },
    isLoadingFilter: { type: Boolean },
    hasMore: { type: Boolean },
    loadingMore: { type: Boolean },
    showInheritance: {},
    canEditAccessLevel: { type: Boolean },
    isMarkedForRemoval: { type: Function },
    getRelationLabel: { type: Function },
    getSelectablePermissions: { type: Function },
    getSortedPermissionsForDisplay: { type: Function },
    resolveResourceName: { type: Function },
    getPendingRelation: { type: Function }
  },
  emits: ["update:filterText", "update:showFilterInput", "clear-filter", "toggle-inheritance", "track-change", "toggle-removal", "end-reached"],
  setup(__props: any, { emit }) {





const onEndReached = (isIntersecting: boolean) => {
  if (isIntersecting) emit('end-reached')
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            size: "172",
            indeterminate: ""
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          dense: ""
        }, {
          default: _withCtx(() => [
            (_ctx.permissionGroups.length || _ctx.permissionUsers.length || _ctx.filterText)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (!_ctx.showFilterInput)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "flex items-center justify-between w-full border border-solid border-gray-400 rounded bg-white px-3 py-2 cursor-pointer hover:border-primary hover:bg-gray-50 transition-colors",
                            title: "Clique para buscar e editar permissões",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:showFilterInput', true)))
                          }, [
                            _hoisted_4,
                            _createVNode(_component_v_icon, {
                              icon: _unref(mdiMagnify),
                              color: "primary"
                            }, null, 8, ["icon"])
                          ]))
                        : (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 1,
                            "model-value": _ctx.filterText,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:filterText', $event))),
                            density: "compact",
                            variant: "outlined",
                            color: "primary",
                            label: "Digite o nome do usuário ou grupo",
                            placeholder: "Pressione Esc para cancelar",
                            "hide-details": "",
                            autofocus: "",
                            class: "pt-0 mt-0",
                            loading: _ctx.isLoadingFilter
                          }, {
                            "append-inner": _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                class: "cursor-pointer",
                                icon: _unref(mdiClose),
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('clear-filter')))
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["model-value", "loading"]))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionGroups, (subject) => {
                      return (_openBlock(), _createBlock(PermissionsAccordionItem, {
                        key: subject.subject_id,
                        subject: subject,
                        "is-expanded": _ctx.showInheritance[subject.subject_id],
                        "is-marked-for-removal": _ctx.isMarkedForRemoval(subject.subject_id),
                        "can-edit-access-level": _ctx.canEditAccessLevel,
                        "selectable-permissions": _ctx.getSelectablePermissions(subject),
                        "sorted-permissions": _ctx.getSortedPermissionsForDisplay(subject),
                        "get-relation-label": _ctx.getRelationLabel,
                        "resolve-resource-name": _ctx.resolveResourceName,
                        "pending-relation": _ctx.getPendingRelation(subject.subject_id),
                        onToggle: ($event: any) => (emit('toggle-inheritance', subject.subject_id)),
                        onChangeRelation: (val) => emit('track-change', { subject, val }),
                        onToggleRemoval: ($event: any) => (emit('toggle-removal', subject))
                      }, null, 8, ["subject", "is-expanded", "is-marked-for-removal", "can-edit-access-level", "selectable-permissions", "sorted-permissions", "get-relation-label", "resolve-resource-name", "pending-relation", "onToggle", "onChangeRelation", "onToggleRemoval"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionUsers, (subject) => {
                      return (_openBlock(), _createBlock(PermissionsAccordionItem, {
                        key: subject.subject_id,
                        subject: subject,
                        "is-expanded": _ctx.showInheritance[subject.subject_id],
                        "is-marked-for-removal": _ctx.isMarkedForRemoval(subject.subject_id),
                        "can-edit-access-level": _ctx.canEditAccessLevel,
                        "selectable-permissions": _ctx.getSelectablePermissions(subject),
                        "sorted-permissions": _ctx.getSortedPermissionsForDisplay(subject),
                        "get-relation-label": _ctx.getRelationLabel,
                        "resolve-resource-name": _ctx.resolveResourceName,
                        "pending-relation": _ctx.getPendingRelation(subject.subject_id),
                        onToggle: ($event: any) => (emit('toggle-inheritance', subject.subject_id)),
                        onChangeRelation: (val) => emit('track-change', { subject, val }),
                        onToggleRemoval: ($event: any) => (emit('toggle-removal', subject))
                      }, null, 8, ["subject", "is-expanded", "is-marked-for-removal", "can-edit-access-level", "selectable-permissions", "sorted-permissions", "get-relation-label", "resolve-resource-name", "pending-relation", "onToggle", "onChangeRelation", "onToggleRemoval"]))
                    }), 128)),
                    (!_ctx.permissionGroups.length && !_ctx.permissionUsers.length && _ctx.filterText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Nenhum resultado encontrado para \"" + _toDisplayString(_ctx.filterText) + "\" ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.hasMore)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_ctx.loadingMore)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: "",
                                size: "24",
                                width: "2",
                                color: "primary"
                              }))
                            : _createCommentVNode("", true)
                        ])), [
                          [_directive_intersect, onEndReached]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(CardNoSharedResource)
                    ])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }))
  ]))
}
}

})